export const environment = {
    production: true,
    development: false,
    staging: false,
    version: 'v1',

    //msc
    basicUrl: 'https://gateway-msc.abnaey.com/api',
    staffUrl: 'https://msc.abnaey.com/',
    parentUrl: 'https://parent-msc.abnaey.com/',
    teacherUrl: 'https://teacher_portal-msc.abnaey.com/',
    studentUrl: 'https://student_portal-msc.abnaey.com/',
    dmUrl: 'https://dm-msc.abnaey.com/',
    sponsorUrl: 'https://sponsor_portal-msc.abnaey.com/',
    
    mapsApiKey: 'AIzaSyDZsQEDaOUzZC69BShQQUTW_x_dVVHXO8Y',
  };